module.exports = __webpack_public_path__ + "static/media/ikonnect.183ea08f.jpg";